import { FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { DemoUser, useUser } from "../hooks/useUser";

export function Login() {
  const { setUser } = useUser();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);

    const find = await api<DemoUser & { created: boolean }>(
      "/api/users/find-or-create",
      {
        method: "POST",
        body: JSON.stringify({ email, password, name: name || undefined }),
      }
    );
    if (!find.ok) {
      const body = find.body as { error?: string } | null;
      if (find.status === 401 || body?.error === "invalid_credentials") {
        setError("Email ou senha incorretos.");
      } else if (body?.error === "invalid_input") {
        setError("A senha precisa ter ao menos 6 caracteres.");
      } else {
        setError(`Falha ao entrar (HTTP ${find.status}).`);
      }
      setSubmitting(false);
      return;
    }

    let user = find.body;

    // Link Stripe automaticamente se ainda não tem
    if (!user.stripeCustomerId) {
      const link = await api<{ stripeCustomerId: string }>(
        `/api/users/${user.id}/link-stripe`,
        { method: "POST", body: JSON.stringify({}) }
      );
      if (link.ok) {
        user = { ...user, stripeCustomerId: link.body.stripeCustomerId };
      }
    }

    setUser({
      id: user.id,
      email: user.email,
      name: user.name,
      stripeCustomerId: user.stripeCustomerId,
    });
    navigate("/loja");
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>Entrar</h1>
        <p className="hint">
          Entre com email e senha. Se for um email novo, criamos a conta (e um
          Stripe Customer) automaticamente com a senha informada.
        </p>
        <form onSubmit={onSubmit}>
          <label>
            Email
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
              disabled={submitting}
              autoFocus
            />
          </label>
          <label>
            Senha
            <input
              type="password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Mínimo 6 caracteres"
              disabled={submitting}
              autoComplete="current-password"
            />
          </label>
          <label>
            Nome (opcional)
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Seu Nome"
              disabled={submitting}
            />
          </label>
          {error && <p className="error">{error}</p>}
          <button type="submit" disabled={submitting || !email || password.length < 6}>
            {submitting ? "Entrando..." : "Entrar"}
          </button>
        </form>
        <p className="hint admin-hint">
          Admin? Acesse o painel em <a href="/admin">/admin</a>.
        </p>
      </div>
    </div>
  );
}
